export enum ContactType {
  GENERIC = 'GENERIC',
  LOCATION = 'LOCATION',
  LANDFILL = 'LANDFILL',
  GRAVEL_PLANT = 'GRAVEL_PLANT',
  LANDFILL_GRAVEL_PLANT = 'LANDFILL_GRAVEL_PLANT',
  COMPANY = 'COMPANY',
  CO_CONTRACTOR = 'CO_CONTRACTOR',
}
